const EVENTS = {
  CONTENT: {
    DIMMER_ON: 'on:content:dim:on',
    DIMMER_OFF: 'on:content:dim:off',
    MORE_DROPDOWN_OFF: 'on:content:dropdown:off',
    MORE_DROPDOWN_ON: 'on:content:dropdown:on'
  },
  CTRL: {
    DEFAULT: 'content',
    CONTENT: 'content',
    SECONDARY: 'secondary',
    PRIMARY: 'primary',
    ALL: 'all'
  },
  SWIPE: {
    X: 150
  },
  FAVOURITES: {
    CHANGE: 'favourites:change'
  }
}

export default EVENTS
